import React from "react";

import { Router } from "src/router/Router";

export const App: React.FC = () => {
  return (
    <div className="flex h-screen w-screen flex-col overflow-clip">
      <Router />
    </div>
  );
};
